import { compose, withHandlers, withStateHandlers } from 'recompose';
import { filter, set, unset } from 'lodash/fp';

function withFilter(initialFilters = {}) {
  return compose(
    withStateHandlers(
      {
        filters: initialFilters
      },
      {
        onFilter({ filters }) {
          return (field, value) =>
            value !== undefined
              ? {
                  filters: set(field, value, filters)
                }
              : {
                  filters: unset(field, filters)
                };
        },
        onFilterReset() {
          return () => ({
            filters: {}
          });
        }
      }
    ),
    withHandlers({
      filterData({ filters }) {
        return filter(filters);
      }
    })
  );
}

export default withFilter;
